import { ReactNode, ReactElement } from 'react';
import { Tokens } from './tokens';
import { TokensContext } from './context';

type Props = {
    readonly tokens: Tokens;
    readonly children?: ReactNode;
};
export function TokensProvider({ tokens, children }: Props): ReactElement {
    return (
        <TokensContext.Provider value={{ tokens }}>
            {children}
        </TokensContext.Provider>
    );
}
